/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, EffectCallback} from 'react';

/** @module hooks/useEffectOnMount */

/**
 * UseEffect hook only runs when component is mounted
 * @param  callback - Imperative function that can return a cleanup function
 *
 * @memberof module:hooks/useEffectOnMount
 *
 * @example
 * useEffectOnMount(() => {
 *   console.log('mounted');
 *   return () => console.log('unmounted');
 * });
 */
export const useEffectOnMount = (callback: EffectCallback) =>
    useEffect(callback, []);
